module.exports = __webpack_public_path__ + "static/media/reportatge-magazinepublicacions-2.7dffe95e.jpg";